function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#5F37FF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.3047 5H6V15H10.6978C11.7002 15 12.5061 14.7331 13.0958 14.1786C13.6855 13.6448 14 12.9261 14 12.0431C14 11.345 13.7445 10.77 13.2531 10.2772L12.172 11.0164C12.4275 11.3039 12.5651 11.6324 12.5651 12.0021C12.5651 12.4949 12.3882 12.885 12.0344 13.1725C11.6806 13.46 11.1892 13.6037 10.5602 13.6037H7.51351V6.41684H10.226C11.3268 6.41684 11.8968 6.86858 11.8968 7.73101C11.8968 8.6345 11.3268 9.08624 10.226 9.08624H8.47666V10.4825H10.3047C11.2088 10.4825 11.9558 10.2361 12.5061 9.70226C13.0565 9.18891 13.3514 8.51129 13.3514 7.64887C13.3514 6.82752 13.0762 6.17043 12.5258 5.69815C11.9754 5.24641 11.2285 5 10.3047 5Z",
  fill: "white"
});

var SvgBcoin = function SvgBcoin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBcoin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bcoin.a09b4b24.svg";
export { ForwardRef as ReactComponent };